import { useTranslation } from "react-i18next";
import saveIcon from "../../../../../assets/design-revamp-company/system-boundary-subcategory/saveIcon.svg";
import { useUserAccess } from "../../../../../components/WriteAccessContext";
const SystemBoundary = ({
  systemBoundary,
  setSystemBoundary,
  productId,
  customStyles,
  isTransportDelivery,
  createSystemBoundaryFunc,
  isManufacturing,
}) => {
  const { t } = useTranslation();
  const { userAccess } = useUserAccess();
  const handleSave = () => {
    createSystemBoundaryFunc({
      productId: productId,
      systemBoundary: systemBoundary,
    });
  };
  return (
    <div
      className={
        isTransportDelivery
          ? "system-boundary-box-transport"
          : isManufacturing
          ? "system-boundary-box-manufacturing"
          : "system-boundary-box"
      }
      style={customStyles}
    >
      <h5 style={{ fontWeight: "bold" }}>{t("SYSTEM_BOUNDARY")}</h5>
      <input
        value={systemBoundary}
        placeholder={t("COMMENT_BOUNDARY")}
        onChange={(e) => setSystemBoundary(e.target.value)}
      />
      {userAccess === "write" && (
        <img
          src={saveIcon}
          alt="Save Icon"
          width={20}
          height={20}
          className="sub-icon-save"
          onClick={handleSave}
        />
      )}
    </div>
  );
};

export default SystemBoundary;
